import { useT } from '@transifex/react'
import { useVdFeatureManager } from '../../../../../../ng-compat/hooks'
import { useCrossLocationFulfilmentGate } from '../../../../../sale/sale-line-item/fulfilment/OutletSelect/hooks/useCrossLocationFulfilmentGate'
import type { OutletOption } from '../../../../../sale/sale-line-item/fulfilment/OutletSelect/OutletSelectTypes'
import { STEPS } from '../types'
import type { Step1Props } from './Step1'

export const useStep1Model = (props: Step1Props) => {
  const t = useT()
  const vdFeatureManager = useVdFeatureManager()
  const { canUseCrossLocationFulfilment } = useCrossLocationFulfilmentGate()

  return {
    canUseCrossLocationFulfilment,
    closeLabel: t('Don’t mark as unfulfilled', {
      _context: 'Mark as unfulfilled modal',
    }),
    description: t(
      'Only one fulfilment method can be selected for items that require fulfillment. To record another method, create another sale.',
      {
        _context: 'Mark as unfulfilled modal header description',
      }
    ),
    handlePerLineFulfilmentOutletChange: (outlet: OutletOption) =>
      props.onPerLineFulfilmentOutletChange(outlet.id),
    handleSelectedOutletIdChange: props.onPerLineFulfilmentOutletChange,
    handleClose: () => props.onClose(),
    handleNext: () => props.onStepChange(STEPS.CUSTOMER),
    initialSelectedOutletId: props.perLineFulfilmentOutletId,
    nextLabel: t('Next', {
      _context: 'Mark as unfulfilled modal - next button',
    }),
    shouldShowOutletPicker: vdFeatureManager.get('fulfill_from_another_outlet'),
    title: t(
      '{totalQuantity, plural, one {Choose how the {totalQuantity} item in this sale will be fulfilled} other {Choose how all {totalQuantity} items in this sale will be fulfilled}}',
      {
        totalQuantity: props.totalQuantity,
        _context: 'Mark as unfulfilled modal header',
      }
    ),
  }
}
